module.exports = {"id":"222331","name":"Lukas Klostermann","rating":"75","photo":"./data/images/photos/2/222331.png","club":{"name":"RB Leipzig","logo":"./data/images/clubs/RBLeipzig.png"},"positions":["DD","DG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LukasKlostermann0.json
// module id = 2636
// module chunks = 0